/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);

const $btnOpenModal  = $el.find('[data-open-modal]');
const $modalInvestir = $('[data-component="modals/modal-investir"]');

const $tab = $el.find('.tab');
const $tabContent = $el.find('.tab-content');

$btnOpenModal.on('click tap', function() {
    const $this = $(this);

    const attributes = {
        aditionalAplication: $this.data('aditional-aplication'),
        minAplication: $this.data('min-aplication'),
        minBalance: $this.data('min-balance'),
        platforms: $this.data('platforms'),
        productName: $this.data('product-name'),
        isInstitucional: ($this.data('institucional') !== undefined) ? true : false,
    }

    $modalInvestir.trigger('open', [attributes]);
});


$tab.on('click tap', function(e) {
    const $this = $(this);
    const dataTarget = $this.data('target');

    $tabContent.add($tab).removeClass('active');
    $el.find(`[data-tab="${dataTarget}"]`).add($this).addClass('active');
});
